<template>

    <div class="card card-content">
        
<v-card  :width ="$vuetify.breakpoint.xs ? '70vw' : '40vw'" class="m4u_tertiary m4u_text--text mx-auto">

<v-card-text class="m4u_tertiary m4u_text--text">
<v-row justify-start>
<v-col
  md="4">
  {{question.ViewPointDate}}
</v-col>
<v-col
  md="4">
{{question.ViewPointQ}}
</v-col>
</v-row>
</v-card-text>
<v-card-actions>
       <v-dialog
      v-model="editQuestionDialog"
      persistent
       :modalAppendToBody="false"
      max-width="600px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
        icon
        color="primary"
        class="m4u_text--text"
        v-bind="attrs"
        v-on="on"
        @click="getThisQCQuestion(question)"
        >
          <v-icon class="m4u_text--text">mdi-pencil</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Quick Connect Question</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
              >
                <v-text-field
                  v-model="editQuestion.ViewPointDate"
                  label="Date"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
              >
                <v-text-field
                v-model="editQuestion.ViewPointQ"
                  label="Question"
                ></v-text-field>
              </v-col>

            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="teal"
            text
            @click="editQuestionDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="teal"
            text
            @click="saveQuestion(question.ViewPointID)"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> 
 <v-btn icon @click="deleteQuestion(question)"><v-icon class="m4u_text--text">mdi-delete-alert-outline</v-icon></v-btn>
</v-card-actions>
</v-card>
    </div>
</template>
<script>
import EventService from '@/services/EventService.js'; 

export default {
    name: 'QCManageCard',
  data() {
    return {
        editQuestion: [],
        newQuestionDialog: false,
        editQuestionDialog: false,
        qcQuestion: '',
        qcDate: '',
       }
    },
  props: ["question"],
 mounted() {
   
    this.editQuestion = this.question
  },
   computed: {
  user(){
    return this.$store.state.user
  },

    loginState(){
    return this.$store.state.loginState
  },
  
   },
 methods: {

      async getThisQCQuestion(question) {
       this.editQuestionDialog = true;
      await EventService.getThisQCQuestion(question.ViewPointID)
      .then(
        (question => {
          this.$set(this, "editQuestion", question[0]);
        }).bind(this)
      );
    },

      async saveQuestion(ViewPointID) {
        this.editQuestionDialog = false
      await EventService.editThisQCQuestion(ViewPointID, this.editQuestion.ViewPointQ, this.editQuestion.ViewPointDate, this.user.UserID)
      .then(
        (questionreply => {
        this.$emit('refreshQuestions', ViewPointID);  
        })

      );
    },

    async deleteQuestion(question) {
      await EventService.deleteQuickConnectQuestion(question.ViewPointID)
      .then(
        async () => {
          this.$emit('refreshQuestions', 'deletedItem');  
        }
      );
    },

 }
}


</script>
<style lang="scss" scoped>
.card {

  height: auto;
  background-position: center;
  background-size: cover;
  text-align: center;
}
.card-content {
  color: #fff2e6;
  background-color: rgba(0, 0, 0, 0.35);


  span {
    font-size: 18px;
    text-align: center;
    width: 100%;
    position: absolute;
    bottom: 10px;
    right: 0;
  }
  h2 {
    margin-top: 10px;
  }
}

.custom-label-color .v-label {
  color: #250E62;
  opacity: 1;
}

.event-date {
  background-color: #151515;
  color: #fff;
  font-size: 0.75em;
  padding: 2px 10px;
  position: absolute;
  top: 0;
  right: 0;
}

.myAnswerDiv{
  display: inline;
}

.myAnswerField{
  max-width: 80%;
}
.questionDiv {
  display: block;
}
</style>